import axios from "axios";
import Constants from "../../../components.constants.js";

export default {

    async getJobsWidgetDataFromServer(context, payload = {}) {

        try {
            let resp = await axios.get(Constants.jobsUrl + '/dashboard', payload);
            if (resp.status == 200) {
                resp.data.statusCode = resp.status
                return resp.data;
            } else {
                throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
            }
        } catch (error) {
            console.error(
                `[getJobsWidgetDataFromServer][Store][Error occured while getting jobs data--->${error}]`
            );
            if (error.response) {
                if (error.response.status == 401) {
                    return context.dispatch("users/logOutFromServer", {}, { root: true })
                } else {
                    error.response.data.statusCode = error.response.status
                    return error.response.data
                }
            }
            return {}
        }
    },

    async addToDashboard(context, payload = {}) {
        try {
            let resp = await axios.post(Constants.dashboardWidgetsUrl + "/my-dashboard", payload);
            if (Constants.acceptedStatusCodes.includes(resp.status)) {
                console.log(
                    `[addToDashboard][Store][Widget update resp-->${resp.status}]`
                );
                resp.data.statusCode = resp.status
                return resp.data;
            } else {
                throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
            }
        } catch (error) {
            console.error(
                `[addToDashboard][Store][Error occured while updating widget--->${error}]`
            );
            if (error.response) {
                if (error.response.status == 401) {
                    return context.dispatch("logOutFromServer")
                } else {
                    error.response.data.statusCode = error.response.status
                    return error.response.data
                }
            }
            return {}
        }
    },

    async getAllWidgetsFromServer(context, payload = {}) {
        try {
            let resp = await axios.get(Constants.dashboardWidgetsUrl + "/all-widgets", payload);
            if (Constants.acceptedStatusCodes.includes(resp.status)) {
                resp.data.statusCode = resp.status
                return resp.data;
            } else {
                throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
            }
        } catch (error) {
            console.error(
                `[getAllWidgetsFromServer][Store][Error occured while getting all widgets info --->${error}]`
            );
            if (error.response) {
                if (error.response.status == 401) {
                    return context.dispatch("users/logOutFromServer", {}, { root: true })
                } else {
                    error.response.data.statusCode = error.response.status
                    return error.response.data
                }
            }
            return {}
        }
    },

    async getInstalledWidgetsOfUserFromServer(context, payload = {}) {
        try {
            let resp = await axios.get(Constants.dashboardWidgetsUrl + "/my-dashboard", payload);
            if (Constants.acceptedStatusCodes.includes(resp.status)) {
                resp.data.statusCode = resp.status
                return resp.data;
            } else {
                throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
            }
        } catch (error) {
            console.error(
                `[getInstalledWidgetsOfUserFromServer][Store][Error occured while getting installed widgets info --->${error}]`
            );
            if (error.response) {
                if (error.response.status == 401) {
                    return context.dispatch("users/logOutFromServer", {}, { root: true })
                } else {
                    error.response.data.statusCode = error.response.status
                    return error.response.data
                }
            }
            return {}
        }
    },

    async updateWidgetWithProjectId(context, payload = {}) {
        try {
          let resp = await axios.put(`${Constants.dashboardWidgetsUrl + '/my-dashboard'}/${payload._id}`, payload);
          if (resp.status == 200) {
            resp.data.statusCode = resp.status
            return resp.data;
          } else {
            throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
          }
        } catch (error) {
          console.error(
            `[updateWidgetWithProjectId][Store][Error occured while updating widget--->${error}]`
          );
          if (error.response) {
            if (error.response.status == 401){
              return context.dispatch("users/logOutFromServer", {},{root:true})
            }else if (error.response.status == 405){
              return {statusCode:error.response.status,message:"failed to update widget"}
            } else {
              error.response.data.statusCode = error.response.status
              return error.response.data
            }
          }
          return {}
        }
      },

      async deleteWidget(context, payload = {}) {
    
        try {
          let resp = await axios.delete(`${Constants.dashboardWidgetsUrl + '/my-dashboard'}/${payload.params}`, payload);
          if (Constants.acceptedStatusCodes.includes(resp.status)) {
            console.log(
              `[deleteWidget][Store][widget Delete resp-->${resp.status}]`
            );
            resp.data.statusCode = resp.status
            return resp.data;
          } else {
            throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
          }
        } catch (error) {
          console.error(
            `[deleteWidget][Store][Error occured while deleting widget--->${error}]`
          );
          if (error.response) {
            if (error.response.status == 401){
              return context.dispatch("users/logOutFromServer", {},{root:true})
            }
            else {
              error.response.data.statusCode = error.response.status
              return error.response.data
            }
          }
          return {}
        }
    
      },

      async getStorageReportFromServer(context) {
        try {
          let resp = await axios.get(Constants.storageReportUrl);
          if (Constants.acceptedStatusCodes.includes(resp.status)) {
            resp.data.statusCode = resp.status
            return resp.data;
          }else {
            throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
          }
        } catch (error) {
          console.error(
            `[getStorageReportFromServer][Store][Error occured while gettingstorage report list--->${error}]`
          );
          if (error.response) {
            if (error.response.status == 401){
              return context.dispatch("users/logOutFromServer", {},{root:true})
            }
            else {
              error.response.data.statusCode = error.response.status
              return error.response.data
            }
          }
          return {}
        }
      },

      async getMediaPipelineDashboardWidget(context, payload = {}) {

        try {
          let resp = await axios.get(`${Constants.mediaPipelineDashboardWidgetUrl}`, payload);
          if (resp.status == 200) {
            resp.data.statusCode = resp.status
            return resp.data;
          }else {
            throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
          }
        } catch (error) {
          console.error(
            `[getMediaPipelineDashboardWidget][Store][Error occured while getting Assetslist--->${error}]`
          );
          if (error.response) {
            if (error.response.status == 401){
              return context.dispatch("users/logOutFromServer", {},{root:true})
            }
            else {
              error.response.data.statusCode = error.response.status
              return error.response.data
            }
          }
          return {}
        }
      },
};